/**
 * <TutorQuizFirstMention> — « Quiz d'abord », la chip qui porte ses options (molecule).
 *
 * L'ancienne mention de la fiche du tuteur (`QuizFirstMention.js`) : l'élève passe par le quiz de
 * prérequis avant l'énoncé, et le tuteur peut le retirer. La même au centre du live
 * (`<TutorLiveCenter>`) et dans la fiche (`<TutorActivityDetailsModal>`).
 *
 * La chip ouvre ses options (« Retirer le quiz ») : plus de bouton « Retirer » à côté d'elle (Wajih, 05/11 : un
 * badge collé à un gros bouton était mal fait). Pendant le retrait, elle le dit et ne s'ouvre plus.
 */
import React from "react"

import { ChoiceChip } from "../../atoms/ChoiceChip"
import { ThreeDotMenu } from "../ThreeDotMenu"

export type TutorQuizFirstMentionProps = {
    onRemove: () => void
    /** Le retrait part. Défaut `false`. */
    removing?: boolean
    testID?: string
}

const TEXTS = {
    quizFirst: "Quiz d'abord",
    removing: "Retrait du quiz…",
    options: "Quiz d'abord : l'élève passe le quiz de prérequis avant l'énoncé. Ouvrir ses options",
    remove: "Retirer le quiz",
}

export function TutorQuizFirstMention(props: TutorQuizFirstMentionProps) {
    const { onRemove, removing = false, testID } = props
    return (
        <ThreeDotMenu
            items={[{ icon: "times", text: TEXTS.remove, onPress: onRemove }]}
            trigger={({ onPress, open }) => (
                <ChoiceChip
                    label={removing ? TEXTS.removing : TEXTS.quizFirst}
                    iconName="tasks"
                    action
                    selected={open}
                    expanded={open}
                    disabled={removing}
                    onPress={onPress}
                    accessibilityLabel={removing ? TEXTS.removing : TEXTS.options}
                    testID={testID}
                />
            )}
        />
    )
}
